import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getCompanyAction } from "../../../store/slices/app/actions/getCompanyAction";
import { getGradesAction } from "../../../store/slices/app/actions/gradeActions";
import { getSubjectsAction } from "../../../store/slices/app/actions/subjectActions";
import { getTeachersAction } from "../../../store/slices/app/actions/teacherActions";
import { getTimeframesAction } from "../../../store/slices/app/actions/timeframeActions";
import { getWeekdaysAction } from "../../../store/slices/app/actions/getWeekdaysAction"; // Import getWeekdaysAction
import Navigation from "../navigation/Navigation";
import Shortcut from "../navigation/Shortcut";
import Footer from "./Footer";
import Header from "./Header";

const CHANGE_PASSWORD_PATH = "/changePassword";

const Layout = ({ element }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const mustChangePassword = userInfo?.changePasswordRequired && location.pathname !== CHANGE_PASSWORD_PATH;

  useEffect(() => {
    dispatch(getCompanyAction());
    dispatch(getGradesAction());
    dispatch(getSubjectsAction());
    dispatch(getTimeframesAction());
    dispatch(getTeachersAction());
    dispatch(getWeekdaysAction()); 
  }, [dispatch]);

  useEffect(() => {
    if (mustChangePassword) {
      navigate(CHANGE_PASSWORD_PATH, { replace: true });
    }
  }, [mustChangePassword, navigate]);

  return (
    <div>
      <Header />
      <Navigation />
      <div id="main" role="main">
        {mustChangePassword ? null : element}
      </div>
      <Footer />
      <Shortcut />
    </div>
  );
};

Layout.propTypes = {
  element: PropTypes.element.isRequired,
};

export default Layout;
